import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "finish"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CircleCheckFilled = _resolveComponent("CircleCheckFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", {
    class: _normalizeClass(_ctx.$store.state.interval2 ? '' : 'finish-show'),
    style: _normalizeStyle({
      transform: $setup.X
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CircleCheckFilled)]),
    _: 1
  }), _cache[0] || (_cache[0] = _createTextVNode("任务已提交，等待响应 "))], 6)]);
}